if (window.quizInitialized) {
    console.log("Quiz already initialized.");
} else {

window.quizInitialized = true;

// =====================================================
// ALWAYS ESSENTIAL QUIZ ENGINE V7
// PART 1 OF 5
// =====================================================


// -----------------------------------------------------
// Detect Quiz
// -----------------------------------------------------

const path = window.location.pathname;

let currentQuiz = null;
let currentResults = null;

if (path.includes("know-your-skin")) {

    currentQuiz = quizzes["know-your-skin"];
    currentResults = quizResults;

}
else if (path.includes("should-you-use-a-face-oil")) {

    currentQuiz = quizzes["should-you-use-a-face-oil"];
    currentResults = faceOilResults;

}

if (!currentQuiz) {

    console.error("Quiz not found:", path);

}


// -----------------------------------------------------
// Elements
// -----------------------------------------------------

const title = document.getElementById("quiz-title");

const question = document.getElementById("question");

const answers = document.getElementById("answers");

const insightBox =
document.getElementById("answer-insight");

const progressText =
document.getElementById("progress-text");

const progressPercent =
document.getElementById("progress-percent");

const progressFill =
document.getElementById("progress-fill");

const confidenceLabel =
document.getElementById("analysis-confidence");

const nextBtn =
document.getElementById("nextBtn");

const prevBtn =
document.getElementById("prevBtn");

const resultBox =
document.getElementById("result");

const analysisScreen =
document.getElementById("analysis-screen");

const progressWrapper =
document.querySelector(".progress-wrapper");

const quizButtons =
document.querySelector(".quiz-buttons");

const container =
document.querySelector(".quiz-container");


// -----------------------------------------------------
// State
// -----------------------------------------------------

let currentQuestion = 0;

let selectedAnswers = [];


// -----------------------------------------------------
// Analysis Stages
// -----------------------------------------------------

const analysisStages = [

    "Analyzing hydration...",

    "Evaluating oil balance...",

    "Assessing skin barrier...",

    "Checking sensitivity...",

    "Reviewing pore behavior...",

    "Comparing skin patterns...",

    "Analyzing daily habits...",

    "Building skin profile...",

    "Generating recommendation...",

    "Preparing results..."

];


// -----------------------------------------------------
// Init
// -----------------------------------------------------

title.textContent =
currentQuiz.title;


// =====================================================
// RENDER QUESTION
// =====================================================

function renderQuestion() {

    container.classList.remove("fade-in");

    container.classList.add("fade-out");

    setTimeout(() => {

        const q =
        currentQuiz.questions[currentQuestion];

        progressText.innerHTML = `

<div>

Question ${currentQuestion + 1}
of
${currentQuiz.questions.length}

</div>

<div class="analysis-stage">

${analysisStages[currentQuestion]}

</div>

`;

        const percentage =

((currentQuestion + 1) /
currentQuiz.questions.length) * 100;

        progressPercent.textContent =

`${Math.round(percentage)}%`;

        progressFill.style.width =

`${percentage}%`;

        const confidence =

Math.min(

95,

Math.round(

20 +

((currentQuestion + 1) /
currentQuiz.questions.length) * 75

)

);

        confidenceLabel.textContent =

`Analysis Confidence: ${confidence}%`;

        question.textContent =
        q.question;

        answers.innerHTML = "";

        insightBox.classList.remove("show");

        insightBox.innerHTML = "";

        q.answers.forEach((answer,index)=>{

            const button =
            document.createElement("button");

            button.className = "answer";

            button.textContent =
            answer.text;

            if(selectedAnswers[currentQuestion]===index){

                button.classList.add("selected");

            }

            button.onclick = ()=>{

                selectedAnswers[currentQuestion]=index;

                insightBox.innerHTML =
                answer.insight || "";

                insightBox.classList.add("show");

                nextBtn.disabled = false;

                setTimeout(()=>{

                    if(currentQuestion < currentQuiz.questions.length-1){

                        currentQuestion++;

                        renderQuestion();

                    }

                    else{

                        showResults();

                    }

                },900);

            };

            answers.appendChild(button);

        });

        prevBtn.style.visibility =

currentQuestion===0
?
"hidden"
:
"visible";

        nextBtn.disabled =

selectedAnswers[currentQuestion]==null;

        nextBtn.textContent =

currentQuestion===currentQuiz.questions.length-1

?

"Finish"

:

"Next";

        container.classList.remove("fade-out");

        container.offsetHeight;

        container.classList.add("fade-in");

    },150);

}

// =====================================================
// SCORE CALCULATION
// =====================================================

function calculateScores() {

    const scores = {};

    const insights = [];

    selectedAnswers.forEach((selectedIndex, questionIndex) => {

        if (selectedIndex == null) return;

        const answer =
            currentQuiz.questions[questionIndex]
            .answers[selectedIndex];

        // ----------------------------
        // Add Scores
        // ----------------------------

        if (answer.score) {

            Object.entries(answer.score).forEach(([type, value]) => {

                scores[type] =

                    (scores[type] || 0) + value;

            });

        }

        // ----------------------------
        // Collect Insights
        // ----------------------------

        if (answer.insight) {

            insights.push(answer.insight);

        }

    });

    return {

        scores,

        insights

    };

}



// =====================================================
// FIND WINNER
// =====================================================

function getWinner() {

    const calculated = calculateScores();

    let winner = null;

    let highest = -1;

    Object.entries(calculated.scores).forEach(([type, value]) => {

        if (value > highest) {

            highest = value;

            winner = type;

        }

    });

    return {

        winner,

        score: highest,

        scores: calculated.scores,

        insights: calculated.insights

    };

}



// =====================================================
// PROFILE LABELS
// =====================================================

function formatLabel(label) {

    switch (label) {

        case "hydration":
            return "Hydration";

        case "barrier":
            return "Barrier Health";

        case "oilBalance":
            return "Oil Balance";

        case "sensitivity":
            return "Sensitivity";

        default:
            return label;

    }

}



// =====================================================
// PROFILE BARS
// =====================================================

function createProfileBars(profile) {

    return Object.entries(profile)

        .map(([label, value]) => `

<div class="profile-row">

    <div class="profile-label">

        ${formatLabel(label)}

    </div>

    <div class="profile-bar">

        <div
            class="profile-fill"
            data-width="${value}"
            style="width:0%;">

        </div>

    </div>

    <div class="profile-value">

        ${value}%

    </div>

</div>

`)

.join("");

}

// =====================================================
// RESULTS
// =====================================================

function showResults() {

    const result = getWinner();

    const data = currentResults[result.winner];

    const totalScore =
        Object.values(result.scores)
        .reduce((a, b) => a + b, 0);

    const confidence =

        totalScore > 0

        ? Math.round(
            (result.score / totalScore) * 100
        )

        : (data.confidence || 90);



    // ----------------------------------
    // Hide Quiz
    // ----------------------------------

    progressWrapper.style.display = "none";

    question.style.display = "none";

    answers.style.display = "none";

    quizButtons.style.display = "none";



    // ----------------------------------
    // Show Analysis Screen
    // ----------------------------------

    analysisScreen.style.display = "flex";



    const steps =

        document.querySelectorAll(".analysis-step");



    steps.forEach(step =>

        step.classList.remove("show")

    );



    steps.forEach((step, index) => {

        setTimeout(() => {

            step.classList.add("show");

        }, index * 500);

    });



    // ----------------------------------
    // Build Recommendation
    // ----------------------------------

    let recommendationHTML = "";



    if (data.recommendation.recommended) {

        recommendationHTML = `

<h3>

Recommended Product

</h3>

<strong>

${data.recommendation.product}

</strong>

<p>

${data.recommendation.reason}

</p>

<a

href="${data.recommendation.url}"

class="quiz-product-button">

${data.recommendation.button}

</a>

`;

    }

    else {

        recommendationHTML = `

<h3>

${data.recommendation.title}

</h3>

<p>

${data.recommendation.reason}

</p>

`;

    }



    // ----------------------------------
    // Delay before showing report
    // ----------------------------------

    setTimeout(() => {

        analysisScreen.style.display = "none";

        resultBox.style.display = "block";

                resultBox.innerHTML = `

<div class="result-header">

    <h2>${data.title}</h2>

    <div class="confidence">

        <span id="confidence-number">0</span>% Match

    </div>

</div>

<p class="result-description">

${data.description}

</p>

<div class="result-grid">

<div class="result-card">

<h3>Characteristics</h3>

<ul>

${data.characteristics.map(item=>`<li>${item}</li>`).join("")}

</ul>

</div>

<div class="result-card">

<h3>Daily Advice</h3>

<ul>

${data.dailyAdvice.map(item=>`<li>${item}</li>`).join("")}

</ul>

</div>

<div class="result-card">

<h3>Common Mistakes</h3>

<ul>

${data.commonMistakes.map(item=>`<li>${item}</li>`).join("")}

</ul>

</div>

</div>

<div class="insights-section">

<h3>Why we reached this conclusion</h3>

<ul>

${result.insights.map(item=>`<li>${item}</li>`).join("")}

</ul>

</div>

${data.profile ? `

<div class="profile-section">

<h3>Skin Profile</h3>

${createProfileBars(data.profile)}

</div>

` : ""}

${recommendationHTML}

<button id="retakeBtn">

Retake Quiz

</button>

`;



        document

            .getElementById("retakeBtn")

            .onclick = resetQuiz;



        // -------------------------
        // Confidence Counter
        // -------------------------

        const confidenceNumber =

            document.getElementById("confidence-number");



        let current = 0;



        const counter = setInterval(()=>{

            current++;

            confidenceNumber.textContent = current;

            if(current >= confidence){

                clearInterval(counter);

            }

        },10);



        // -------------------------
        // Animate Profile Bars
        // -------------------------

        setTimeout(()=>{

            document

            .querySelectorAll(".profile-fill")

            .forEach(bar=>{

                bar.style.width =

                bar.dataset.width + "%";

            });

        },250);



    },2600);

}

// =====================================================
// RESET
// =====================================================

function resetQuiz() {

    currentQuestion = 0;

    selectedAnswers = [];

    resultBox.style.display = "none";

    if (analysisScreen) {

        analysisScreen.style.display = "none";

    }

    progressWrapper.style.display = "";

    question.style.display = "";

    answers.style.display = "";

    quizButtons.style.display = "flex";

    progressFill.style.width = "0%";

    progressPercent.textContent = "0%";

    confidenceLabel.textContent = "";

    if (insightBox) {

        insightBox.innerHTML = "";

        insightBox.classList.remove("show");

    }

    renderQuestion();

}


// =====================================================
// BUTTONS
// =====================================================

nextBtn.onclick = () => {

    if (selectedAnswers[currentQuestion] == null) {

        return;

    }

    if (currentQuestion < currentQuiz.questions.length - 1) {

        currentQuestion++;

        renderQuestion();

    }

    else {

        showResults();

    }

};

prevBtn.onclick = () => {

    if (currentQuestion === 0) {

        return;

    }

    currentQuestion--;

    renderQuestion();

};


// =====================================================
// START
// =====================================================

renderQuestion();

}